import { useFormikContext } from "formik";
import { useEffect } from "react";

interface IPriceCheckerProps {
  setSelectPayType: React.Dispatch<React.SetStateAction<any>>; // 결제수단
}
// 결제 정보 세팅 (폼 schema에 영향)
const PayTypeChecker = ({ setSelectPayType }: IPriceCheckerProps) => {
  const { values, setFieldValue } = useFormikContext<any>();

  useEffect(() => {
    setSelectPayType(values?.selectPayType);
  }, [values.selectPayType]);
  return null;
};

export default PayTypeChecker;
